import { request } from '@/common/services/request';

export const queryStoreDirectory = (params) =>
  request('/api/operations/tenant/store-directory', {
    method: 'GET',
    params,
  });

export const queryStoreDirectorySummary = (params) =>
  request('/api/operations/tenant/store-directory-summary', {
    method: 'GET',
    params,
  });

export const queryAllStoreDirectory = async (params) => {
  const data = [];
  let current = 1;
  let response;
  do {
    // eslint-disable-next-line no-await-in-loop
    response = await queryStoreDirectory({ ...params, current, pageSize: 100 });
    data.push(...(response.data || []));
    current += 1;
  } while (response.data?.length && data.length < (response.meta?.total ?? data.length));
  return { ...response, data };
};
